import React, { useEffect } from 'react';

import List from '@sv-support-sdk/ui-components/src/components/Lists/List';
import Headline from '@sv-support-sdk/ui-components/src/components/Typography/Headline';

import PageContentInner from '../../components/Layout/Page/PageContentInner';
import Card from '../../components/Panels/Card';
import LoaderFallback from '../../components/Feedback/Loader/LoaderFallback';

import { useAppDispatch, useAppSelector } from '../../store/hooks';
import helpCenterActions from '../../store/actions/helpCenter';
import { grandCategoriesSelector, selectLoading } from '../../store/selectors/helpCenter';
import { routes } from '../../routing';
import { $l } from '../../locales';
import useMobileDetect from '../../hooks/useMobileDetect';
import { SUPPORT_HELP_CENTER_CATEGORY_CARD } from '../../constants/qaAttributes';

const HelpCenter = () => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectLoading);
  const categories = useAppSelector(grandCategoriesSelector);
  const isMobile = useMobileDetect();

  useEffect(() => {
    dispatch(helpCenterActions.getCategories());
    dispatch(
      helpCenterActions.getTopics({
        noteTitle: $l('HELP_CENTER_TOPIC.NOTE'),
        tipTitle: $l('HELP_CENTER_TOPIC.TIP'),
      }),
    );
  }, [dispatch]);

  if (loading.categories) {
    return (
      <PageContentInner height="full">
        <LoaderFallback />
      </PageContentInner>
    );
  }

  if (!categories.length) {
    return null;
  }

  return (
    <PageContentInner>
      <Headline className="indent-xl-bottom">{$l('HELP_CENTER.TITLE')}</Headline>
      <List isResponsive type="grid" columns="3" gap="24" indents="0-0-24">
        {categories &&
          categories.map((category) => (
            <Card
              key={category.id}
              link={`${routes.articles}/${category.slug}`}
              icon={category.icon ? category.icon : { name: '32--account-circle' }}
              title={category.name}
              description={category.description}
              goToAction={
                isMobile
                  ? undefined
                  : { title: $l('HELP_CENTER.EXPLORE_ARTICLES'), icon: '24--arrow-forward' }
              }
              qaId={`${SUPPORT_HELP_CENTER_CATEGORY_CARD}-${category.slug}`}
            />
          ))}
      </List>
    </PageContentInner>
  );
};

export default HelpCenter;
